import type { ProductTrendFilter } from "@acto/gql/graphql";
import type { AnalysisFilterProperties } from "@acto/taskpane/core/analytics";

interface AnalysisFilterState {
  dateRange: { startDate: string; endDate: string };
  isCustomRange: boolean;
  currentGroup: { name: string } | undefined;
  trends: ProductTrendFilter[] | undefined;
}

/** Derives the `filters` payload of the analysis-viewed events from the page's control state. */
export function buildAnalysisFilters({
  dateRange,
  isCustomRange,
  currentGroup,
  trends,
}: AnalysisFilterState): AnalysisFilterProperties {
  return {
    period: `${dateRange.startDate}_${dateRange.endDate}`,
    periodType: isCustomRange ? "custom" : "predefined",
    productGroup: currentGroup?.name,
    // Single-select: the trend directions are mutually exclusive, so at most one entry.
    quickFilter: trends?.[0]?.toLowerCase(),
  };
}
